var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxInLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4192 10.0452L48.4525 9.95681L24.4972 0.592461L0.60553 10.0183L0.527439 9.98729L0.527519 10.0478L0.524155 10.0497L0.527535 10.0599L0.566885 40.0406L24.5504 49.4478L48.5127 40.0757L48.4732 10.0232L48.4192 10.0452ZM24.4773 2.42988L32.602 5.34224L10.4754 13.9147L2.97243 10.9531L24.4773 2.42988ZM23.6932 47.3291L14.7104 43.7004L10.2025 42.0055L2.27855 38.8775L2.24394 12.5042L10.0883 15.6005L10.097 22.1951C10.097 22.1951 10.5018 22.3167 10.7529 22.4169L10.9906 22.5358L11.2282 22.6546L14.0169 23.8679L11.941 22.8925L12.5622 23.1843L12.8515 23.3203L13.1421 23.4568L14.0169 23.8679L14.0081 17.1475L14.7063 17.4233L23.6587 20.9564L23.6932 47.3291ZM24.513 19.4561L15.7549 15.9985L37.3326 7.27091L46.2412 10.9023L24.513 19.4561ZM46.7991 38.9104L25.4052 47.3304L25.3706 20.9578L46.7625 12.5366L46.7971 38.9098L46.7991 38.9104Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4103 41.4365L37.3256 37.7262L37.3609 39.2258L28.4455 42.9361L28.4103 41.4365Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3517 38.9375L37.2671 35.2272L37.3023 36.7268L28.3869 40.4371L28.3517 38.9375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2931 36.4385L37.2085 32.7282L37.2437 34.2277L28.3283 37.9381L28.2931 36.4385Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxInLogo);
export default __webpack_public_path__ + "static/media/box-in-logo.69326af5.svg";
export { ForwardRef as ReactComponent };